import {
  createSlice,
} from "@reduxjs/toolkit";
import {
  OutputConfigBandMap,
  OutputConfigEditRootMap,
  OutputConfigRootMap
} from "../Api/Types";
import { DefaultFromEntry, DefaultToEntry } from "../Banding/BandingAgeForm/MockData";
import { AgeRangeType, AgeTypes } from "../Banding/BandingAgeForm/Types";
import { Ethnicity } from "../Banding/BandingEthnicityForm/Data";
import { BandingDetailsProps } from "../Banding/Helper";
import { FinalListItem } from "../FinalOutput/FinalOutputList/Data";
import { Navigation } from "../OutputConfigDialog/DialogNavTabs/Types";
import { OutputMappingItem } from "../OutputMapping/OutputMappingList/Types";
import { TableProps } from "../../../Common/UI/Index";
import { Reducer } from "./Reducer";
import {
  BandingDetails,
  EditConfig,
  InitialState,
  MappingFilters,
  MappingPopupToggle,
  SelectedConfigType
} from "./Types";

const initialState: InitialState = {
  configList: {} as TableProps,
  selectedOutputConfig: {} as SelectedConfigType,
  bandingList: {} as BandingDetails,
  selectedBandingDetails: {} as BandingDetailsProps,
  selectedTab: Navigation.DETAILS,
  selectedGenders: [],
  selectedOutputMapping: {} as MappingPopupToggle,
  mappingFilters: {} as MappingFilters,
  outputMappingList: {} as OutputMappingItem[],
  enableMappingPopupSave: false,
  outputMappingPopupBandData: {} as OutputConfigBandMap[],
  outputMappingPopupConfigData: {} as OutputConfigRootMap,
  outputMappingPopupEditConfigData: {} as OutputConfigEditRootMap,
  selectedAgeRangeFrom: {
    value: DefaultFromEntry.value
  },
  selectedAgeRangeTo: {
    value: DefaultToEntry.value
  },
  formData: {} as FormData,
  editConfig: {} as EditConfig,
  entryData: Ethnicity.entry,
  outputElements: {} as FinalListItem[],
  finalOutputFilterBy: "",
  focusConfigId: "",
  selectedAgeValueFrom: {} as AgeRangeType,
  selectedAgeValueTo: {} as AgeRangeType,
  selectedFromType: AgeTypes.DATE,
  selectedToType: AgeTypes.DATE,
  searchByTagName: ""
};

export const Slice = createSlice({
  initialState,
  name: "output-config",
  reducers: Reducer,
});
